class Validates {
  validateNumberForm = (data: string) => {
    data = data.replace(/[^0-9.]/g, "");
    data = data.replace(/(\..*?)\./g, "$1");
    return data;
  };

  validateDateForm = (data: string) => {
    const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(
      data
    );
    if (dateRegex) {
      const dateParts = data.split("-");
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const day = parseInt(dateParts[2], 10);

      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() + 1 === month &&
        date.getDate() === day
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  validateTextForm = (data: string) => {
    data = data.replace(/[^a-zA-Z ]/g, "");
    return data;
  };

  validateFileSize = (file: File, size: number) => {
    if (file) {
      if (file.size > size * 1024 * 1024) {
        return false;
      } else {
        return true;
      }
    }
  };

  validateSignUp = (data: any[]) => {
    return !(data.length === 0);
  };

  validateImageFile = (file: File) => {
    const isImage = file.type.startsWith("image/");
    return isImage;
  };

  validateVideoFile = (file: File) => {
    const isVideo = file.type.startsWith("video/");
    return isVideo;
  };

  validateExcelFile = (file: File) => {
    const validExcelTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    return validExcelTypes.includes(file.type);
  };

  validatePdfFile = (file: File) => {
    return file.type === "application/pdf";
  };

  validateWordFile = (file: File) => {
    const validWordTypes = [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    return validWordTypes.includes(file.type);
  };

  validateValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  validateValidPassword = (password: string) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

    return passwordRegex.test(password);
  };

  validateValidWebsite = (website: string) => {
    const websiteRegex =
      /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?$/;
    return websiteRegex.test(website) || website === "";
  };
}

const instance = new Validates();
export default instance;
